export const GLOBALSERVERERRORMESSAGE = "Server is not responding";
export const INVALIDTOKENMESSAGEFROMSERVER = "Invalid Token";
export const EMPTYMESSAGEFROMSERVER = "";
export const NULLMESSAGEFROMSERVER = null;
export const UNAUTHORIZEDSERVERMESSAGE = "Unauthorized";
export const UNDEFINEDPROPERTYERRORMESSAGE = `Cannot read properties of undefined (reading '0')`;
export const TOKENEXPIREDERRORMESSAGE = "Token expired.";
export const ACCESSTOKENREVOKEDMESSAGE = "Access Token has been revoked";
export const INVALIDREQUESTURLMESSAGE = "Invalid Request URL.";
